import React, { Component } from "react"
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18n from "../../i18n";
import * as rk from "../../localization/resourceKeys";
import * as T from "../../redux/constants";
import customInputComponent from '../../forms/customInputBronson';
import { ccpaFormValidations } from '../../utils/validations';

class UpdatePhoneNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditPhoneNumber: false,
    }
  }

  componentDidUpdate() {
    ccpaFormValidations();
  }

  validate() {
    let returnValue = Yup.object().shape({
      phone: Yup.string()
        .required(i18n.t(rk.CCPA_FORM_ERROR.PHONE_NUMBER_ERROR))
        .matches(/^\d*$/, { message: i18n.t(rk.CCPA_FORM_ERROR.PHONE_NUMBER_ERROR) })
        .min(10, i18n.t(rk.CCPA_FORM_ERROR.PHONE_NUMBER_ERROR))
        .max(10, i18n.t(rk.CCPA_FORM_ERROR.PHONE_NUMBER_ERROR)),
    })
    return returnValue;
  }

  maskValue(valueToMask) {
    const value = ('' + valueToMask).replace(/\D/g, '')
    const updatedValue = value.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (updatedValue) {
      return '(' + updatedValue[1] + ') ' + updatedValue[2] + '-' + updatedValue[3]
    }
    return value;
  }

  formatPhoneNumber(valueToFormat) {
    const value = ('' + valueToFormat).replace(/\D/g, '')
    const updatedValue = value.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (updatedValue) {
      return updatedValue[1] + '-' + updatedValue[2] + '-' + updatedValue[3]
    }
    return value;
  }

  render() {
    return (
      <>
        <div className={`right-to-correct-row ${this.state.isEditPhoneNumber && "update-email"}`}>
          {this.state.isEditPhoneNumber ? (
            <div>
              <div className="u-m">
                {this.props.correctedPhoneNumberState.isCorrectedPhoneNumber ? (
                  <div className="row-container">
                    <div className="pending-changes-data">
                      <div className="submission-pending-left-container">
                        <div>
                          <span className='right-to-correct-input-label'>{i18n.t(rk.DATA_CORRECTION.PHONE_NUMBER_LABEL)}: </span>{this.formatPhoneNumber(this.props.correctedPhoneNumberState.phone)}
                        </div>
                      </div>
                    </div>
                    <div className="right-row_content_right">
                      <div className="submission-pending-right-container">
                        <div className="pending-text-container u-float-left u-mr">
                          <i className="c-icon-list__icon  c-icon  c-icon--[semantic-checkmark]  u-text-success" aria-hidden="true" role="img"></i>
                          <span className="submission-pending-text">{i18n.t(rk.DATA_CORRECTION.PENDING_CHANGES)}</span>
                        </div>
                        <button
                          className="cancel-btn c-btn u-m-none u-float-right"
                          onClick={() => {
                            this.props.clearCorrectedPhoneNumber();
                            this.setState({ isEditPhoneNumber: false });
                          }}
                          id="cancel-phoneNumber-changes-btn"
                          data-testid="cancel-phoneNumber-changes-btn"
                        >
                          <span className="c-btn__text">
                            {i18n.t(rk.BUTTON.CANCEL)}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <Formik
                    initialValues={{
                      phone: "",
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                      await this.props.saveCorrectedPhoneNumber(values);
                      setSubmitting(false);
                    }}
                    validationSchema={this.validate()}
                  >
                    {props => {
                      const { handleSubmit, values } = props;
                      return (
                        <div className="row-container">
                          <div className="o-layout u-m-none">
                            <div className="o-layout__item u-1/1 u-m-none u-p-none">
                              <Field
                                name="phone"
                                data-testid="phone"
                                placeHolder={i18n.t(rk.COMMON.PHONE_NUMBER)}
                                altPlaceholder={(i18n.t(rk.COMMON.PHONE_NUMBER)).toUpperCase()}
                                type="text"
                                id="phone"
                                maskValue={this.maskValue}
                                component={customInputComponent}
                                error={props.errors.phone}
                                helpContent={props.errors.phone && props.touched.phone ? props.errors.phone : ""}
                              />
                            </div>
                          </div>
                          <div className="right-row_content_right">
                            <div className="btn-wrapper">
                              <button
                                className="cancel-btn c-btn u-m-none u-mr"
                                onClick={() => { this.setState({ isEditPhoneNumber: false }) }}
                                id="cancel-update-phoneNumber-btn"
                                data-testid="cancel-update-phoneNumber-btn"
                              >
                                <span className="c-btn__text">
                                  {i18n.t(rk.BUTTON.CANCEL)}
                                </span>
                              </button>
                              <div className="save-btn-wrapper u-float-right">
                                <button
                                  className="u-m-none c-btn"
                                  data-testid="save-phoneNumber-btn"
                                  id="save-phoneNumber-btn"
                                  onClick={handleSubmit}
                                  disabled={!/^\d+$/g.test(values.phone)}
                                >
                                  <span className="c-btn__text">
                                    {i18n.t(rk.BUTTON.SAVE)}
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }}
                  </Formik>
                )}
              </div>
            </div>
          ) : (
            <div className="row-container">
              <div className="u-m right-to-correct-input-label">{i18n.t(rk.DATA_CORRECTION.PHONE_NUMBER_LABEL)}</div>
              <div className="right-row_content_right">
                <div className="update-btn-wrapper">
                  <button
                    className="update-btn c-btn u-m-none u-mr"
                    onClick={() => { this.setState({ isEditPhoneNumber: true }) }}
                    id="update-phoneNumber-btn"
                    data-testid="update-phoneNumber-btn"
                  >
                    <span className="c-btn__text">
                      {i18n.t(rk.BUTTON.UPDATE)}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

UpdatePhoneNumber.propTypes = {
  correctedPhoneNumberState: PropTypes.object,
  saveCorrectedPhoneNumber: PropTypes.func,
  clearCorrectedPhoneNumber: PropTypes.func,
};

const mapStateToProps = state => ({
  correctedPhoneNumberState: state.rightToCorrectReducer
});

const mapDispatchToProps = dispatch => ({
  saveCorrectedPhoneNumber: values => dispatch({ type: T.RIGHT_TO_CORRECT.UPDATE_PHONE_NUMBER, payload: values }),
  clearCorrectedPhoneNumber: () => dispatch({ type: T.RIGHT_TO_CORRECT.CLEAR_UPDATED_PHONE_NUMBER }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(UpdatePhoneNumber));
